import { Select, Divider, Checkbox, Button, message } from "antd";
import { QFTitle } from "@qualitas/qf-title";
import FormSelect from "../CommonComponents/FormSelect";
import FormUpload from "../CommonComponents/FormUpload";
import FormInput from "../CommonComponents/FormInput";
import FormAddressSelect from "../CommonComponents/FormAddressSelect";
import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import StepsButtons from "../CommonComponents/StepsButtons";
import Input from "antd/es/input/Input";
import { IInvestorDataProps } from "../IDataCollection";

const InvestorData = (props: IInvestorDataProps) => {
  const {
    selectedInvestor,
    advanceStep,
    onChangeInvestor,
    countries,
    activitySectors,
    lastExcerciseIncomes,
    lastExcerciseNetWorths,
    foundsOrigin,
    setSelectedInvestor,
    translations,
    onAddItem,
    errors,
    language,
    handleBeforeUpload,
    onRemoveItem,
  } = props;

  return (
    <div className="investor-step">
      <label className="investor-select">{translations.inversor}:</label>
      <Select
        style={{ width: "100%" }}
        placeholder={selectedInvestor?.institutionLong}
        disabled
      />
      <Divider />
      <QFTitle title={translations.investorData} size="extrabig" />
      <div className="investor-step-form-row">
        <FormSelect
          options={activitySectors}
          mandatory
          field="activitySector"
          optionField="es"
          onChangeInvestor={onChangeInvestor}
          optionName={language}
          value={selectedInvestor.activitySector}
          label={translations?.activitySector}
          error={errors?.activitySector}
          placeholder={translations?.selectAnOption}
        />
		{selectedInvestor?.activitySector === "Otro - Especificar" && (
			<FormInput
				mandatory
				field="otherActivitySector"
          		onChangeInvestor={onChangeInvestor}
				value={selectedInvestor?.otherActivitySector}
				label={translations?.otherActivitySector}
				placeholder={translations?.completeField}
			/>
		)}
        <FormSelect
          options={lastExcerciseIncomes}
          mandatory
          field="lastExcerciseIncome"
          optionField="es"
          onChangeInvestor={onChangeInvestor}
          optionName={language}
          value={selectedInvestor?.lastExcerciseIncome}
          label={translations?.lastExcerciseIncome}
          error={errors?.lastExcerciseIncome}
          placeholder={translations?.selectAnOption}
		  shouldSort={false}
        />
        <FormSelect
          options={lastExcerciseNetWorths}
          mandatory
          field="lastExcerciseNetWorth"
          optionField="es"
          onChangeInvestor={onChangeInvestor}
          value={selectedInvestor?.lastExcerciseNetWorth}
          optionName={language}
          label={translations?.lastExcerciseNetWorth}
          error={errors?.lastExcerciseNetWorth}
          placeholder={translations?.selectAnOption}
		  shouldSort={false}
        />
      </div>
	  <Divider />
      <div className="investor-step-header">
        <QFTitle title={translations?.foundsOrigin} size="extrabig" />
        <Button
          icon={<PlusCircleOutlined />}
          className="add-item-button"
          onClick={() => onAddItem("foundsOrigin")}
        >
          {translations?.add}
        </Button>
      </div>
      <div className="investor-step-form-row">
        {selectedInvestor?.foundsOrigin?.length > 0 &&
          selectedInvestor?.foundsOrigin.map((origin: any, index: number) => (
            <>
              <FormSelect
                field="foundsOrigin"
                label={translations?.foundsOrigin}
                key={origin?.foundsOrigin}
                index={index}
                mandatory
                arrayField="foundsOrigin"
                value={origin?.foundsOrigin}
                options={foundsOrigin}
                optionField="es"
                optionName={language}
                placeholder={translations?.selectAnOption}
                onChangeInvestor={(value: any, field: any) =>
                  onChangeInvestor(value, field, index, "foundsOrigin")
                }
                error={errors?.foundsOrigin?.[index]?.foundsOrigin}
              />
              <FormSelect
                options={
                  foundsOrigin?.find((o: any) => o.es === origin?.foundsOrigin)
                    ?.documentOptions || []
                }
                mandatory
                arrayField="foundsOrigin"
                field="foundsOriginDocument"
                placeholder={translations?.selectAnOption}
                optionField="es"
                onChangeInvestor={(value: any, field: any) =>
                  onChangeInvestor(value, field, index, "foundsOrigin")
                }
                value={origin?.foundsOriginDocument}
                optionName={language}
                label={translations?.documentToUpload}
                disabled={!origin?.foundsOrigin}
                error={errors?.foundsOrigin?.[index]?.foundsOriginDocument}
              />
              <div className="investor-step-form-row two-columns-inline">
                <FormUpload
                  mandatory
				  disabled={!origin?.foundsOriginDocument}
                  translations={translations}
                  label={translations?.supportDocument}
                  uploadedFile={origin?.foundsOriginFile}
                  error={errors?.foundsOrigin?.[index]?.foundsOriginFile}
                  handleBeforeUpload={(e: any) =>
                    handleBeforeUpload(
                      e,
                      false,
                      "foundsOriginFile",
                      index,
                      "foundsOrigin"
                    )
                  }
                />
                <Button
                  type="text"
                  className="remove-item-button"
                  onClick={() => onRemoveItem("foundsOrigin", index)}
                  icon={<CloseOutlined />}
                  disabled={selectedInvestor?.foundsOrigin?.length === 1}
                />
              </div>
            </>
          ))}
      </div>
      <Divider />
      <Checkbox
        checked={selectedInvestor?.ocdeInvestor}
        onChange={(e) => onChangeInvestor(e.target.checked, "ocdeInvestor")}
      >
        {translations.ocdeTitle}
      </Checkbox>
      {selectedInvestor?.ocdeInvestor && (
        <div className="investor-step-form-row two-columns">
          <FormInput
            mandatory
            field="ocdeName"
            onChangeInvestor={onChangeInvestor}
            value={selectedInvestor?.ocdeName}
            label={translations.ocdeName}
            error={errors?.ocdeName}
            placeholder={translations?.completeField}
          />
          <FormSelect
            options={countries}
            mandatory
            onChangeInvestor={onChangeInvestor}
            value={selectedInvestor?.ocdeCountry}
            field="ocdeCountry"
            optionField="idCountry"
            optionName={language === "es" ? "name_lang2" : "name_lang1"}
            label={translations.ocdeCountry}
            error={errors?.ocdeCountry}
            placeholder={translations?.selectAnOption}
          />
          <FormInput
            mandatory
            field="ocdeWebsite"
            onChangeInvestor={onChangeInvestor}
            value={selectedInvestor?.ocdeWebsite}
            label={translations.ocdeWebsite}
            error={errors?.ocdeWebsite}
            placeholder={translations?.completeField}
          />
          <FormInput
            mandatory
            field="ocdeRegistrationNumber"
            onChangeInvestor={onChangeInvestor}
            value={selectedInvestor?.ocdeRegistrationNumber}
            label={translations.ocdeRegistrationNumber}
            error={errors?.ocdeRegistrationNumber}
            placeholder={translations?.completeField}
          />
        </div>
      )}
      <Divider />
      <QFTitle title={translations.taxAddress} size="extrabig" />
      <div className="investor-step-form-row two-columns">
        <FormAddressSelect
          error={errors?.taxAddress}
          fieldKey="taxAddress"
          targetField="taxAddress"
          mandatory
          label={translations?.taxAddress}
          translations={translations}
          initialValue={selectedInvestor?.taxAddress?.taxAddress}
          updateFn={(updater: any) =>
            setSelectedInvestor((prev: any) => ({
              ...prev,
              taxAddress: updater(prev.taxAddress),
            }))
          }
        />
        <FormInput
          field="taxAddress.taxAddressLine2"
          onChangeInvestor={onChangeInvestor}
          value={selectedInvestor?.taxAddressLine2}
          label={translations.addressSecondLine}
          placeholder={translations?.completeField}
        />
      </div>
      {selectedInvestor?.taxAddress && (
        <div className="investor-step-form-row three-columns">
          <Input
            value={`${translations.city}: ${selectedInvestor?.taxAddress?.taxAddressCity}`}
            style={{ width: "100%" }}
            disabled
          />
          <Input
            value={`${translations.country}: ${selectedInvestor?.taxAddress?.taxAddressCountry}`}
            style={{ width: "100%" }}
            disabled
          />
          <Input
            value={`${translations.postalCode}: ${selectedInvestor?.taxAddress?.taxAddressPostalCode}`}
            style={{ width: "100%" }}
            disabled
          />
        </div>
      )}
      <Divider />
      <StepsButtons
        advanceStep={advanceStep}
        steps={4}
        currentStep={1}
        disableLast
        translations={translations}
        nextText={translations?.next}
      />
    </div>
  );
};

export default InvestorData;
